import {
  PanelContainer,
  NodePanelProps,
} from "../../lib/panel/panel-container";
import { PanelZendeskTicket } from "./panel-zendesk-ticket";

export function ZendeskActionNodePanel(props: NodePanelProps<any>) {
  return (
    <PanelContainer nodeProps={props}>
      <PanelZendeskTicket />
    </PanelContainer>
  );
}
